import favoritesManager from './favoritesManager';

// Global initialization for favorites manager
document.addEventListener('DOMContentLoaded', () => {
	// console.log('Favorites Manager: Global initialization');
	
	// Force flush updates when user navigates away or closes the page
	const handleBeforeUnload = () => {
		// Get current user ID from global auth state
		if (window.cincyAuthState && window.cincyAuthState.isAuthenticated) {
			const userId = window.cincyAuthState.user.uid;
			// console.log('Page unload detected, force flushing favorites updates...');
			
			// Force immediate flush (synchronous)
			favoritesManager.forceFlush(userId);
		}
	};
	
	// Add event listeners for page unload
	window.addEventListener('beforeunload', handleBeforeUnload);
	window.addEventListener('pagehide', handleBeforeUnload);
	
	// Also flush on visibility change (when tab becomes hidden)
	document.addEventListener('visibilitychange', () => {
		if (document.hidden && window.cincyAuthState && window.cincyAuthState.isAuthenticated) {
			const userId = window.cincyAuthState.user.uid;
			// console.log('Page hidden, force flushing favorites updates...');
			favoritesManager.forceFlush(userId);
		}
	});
	
	// Expose favorites manager globally for debugging
	window.favoritesManager = favoritesManager;
});

export default favoritesManager; 